import BaseModel from '@/models/BaseModel';

export default class ResultsServiceModel extends BaseModel {

  onFetchSuccess(response) {
    if (response.response.data && response.response.data.data && response.response.data.message) {
      const message_parts = response.response.data.message.split('_')
      message_parts.pop()
      const model_name = message_parts.join('_')
      response.response.data = response.response.data.data[model_name]
    }

    super.onFetchSuccess(response)
  }

  // Route configuration
  privateRoutes() {
    return {
      fetch: process.env.VUE_APP_RESULTS_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/{id}',
      save: process.env.VUE_APP_RESULTS_REPOSITORY_URL + '/api/v1/' + this.modelName() + '',
      update: process.env.VUE_APP_RESULTS_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/{id}',
      create: process.env.VUE_APP_RESULTS_REPOSITORY_URL + '/api/v1/' + this.modelName() + '',
      delete: process.env.VUE_APP_RESULTS_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/{id}',
      fetchConnection: process.env.VUE_APP_RESULTS_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/{id}/connection/{connection}'
    }
  }
}
